import React from "react";

function Icon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16">
            <g className="layer">
                <path
                    fill="var(--color-highlight)"
                    fillRule="evenodd"
                    d="M5.49 2.26c0-.15.09-.35.29-.53.2-.18.43-.26.59-.26H9.6c.16 0 .39.08.59.26.2.18.29.38.29.53v.8H5.49v-.8zm-.74 2.1H12.89v9.46c0 .15-.09.35-.29.53-.2.18-.43.26-.59.26H3.94c-.16 0-.39-.08-.59-.26-.2-.18-.29-.38-.29-.53V4.36h1.68zm-.72-1.3v-.8c0-.57.31-1.08.72-1.45.4-.36.98-.64 1.62-.64H9.6c.64 0 1.22.28 1.62.64.41.36.72.87.72 1.45v.8h3.31c.4 0 .73.29.73.65 0 .36-.33.65-.73.65h-.89v9.46c0 .57-.31 1.09-.72 1.45-.4.36-.98.64-1.62.64H3.95c-.64 0-1.22-.28-1.62-.64-.41-.36-.72-.87-.72-1.45V4.36H.72c-.4 0-.73-.29-.73-.65 0-.36.33-.65.73-.65h3.31zm2.33 3.61c.41 0 .73.29.73.65v4.33c0 .36-.32.65-.73.65-.4 0-.73-.29-.73-.65V7.32c0-.36.33-.65.73-.65zm3.96.65c0-.36-.33-.65-.73-.65-.41 0-.73.29-.73.65v4.33c0 .36.32.65.73.65.4 0 .73-.29.73-.65V7.32z"
                    clipRule="evenodd"
                ></path>
            </g>
        </svg>
    );
}

export default Icon;
